/* eslint-disable @typescript-eslint/no-var-requires */

export const IllusBowl = require('./Illus-Bowl.png');
export const IllusPlate = require('./Illus-Plate.png');
